export const GoogleInAppUpdatePriorities = {
    0: '0 - default',
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5 - highest priority',
};

export const labelForInAppUpdatePriority = (priority?: number): string => {
    return GoogleInAppUpdatePriorities[getOrDefaultInAppUpdatePriority(priority)];
};

export const getOrDefaultInAppUpdatePriority = (priority?: number): number => {
    return priority ?? 0;
};
